import * as React from "react"

import { cn } from "../../lib/utils"

const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className="relative w-full overflow-auto">
    <table
      data-slot="table"
      className={cn("w-full caption-bottom border-2 border-border text-sm", className)}
      {...props} />
  </div>
))


const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead
    data-slot="table-header"
    className={cn("[&_tr]:border-b-2 [&_tr]:border-border", className)}
    {...props} />
))

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody
    data-slot="table-body"
    className={cn("[&_tr:last-child]:border-0", className)}
    {...props} />
))

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot
    data-slot="table-footer"
    className={cn(
      "border-t-2 border-border bg-main font-base text-main-foreground last:[&>tr]:border-b-0",
      className
    )}
    {...props} />
))

const TableRow = React.forwardRef(({ className, ...props }, ref) => (

    <tr
      data-slot="table-row"
      className={cn(
        "border-b-2 border-border transition-colors text-main-foreground bg-main font-base data-[state=selected]:bg-secondary-background data-[state=selected]:text-main-foreground",
        className
      )}
      {...props} />
  ))

const TableHead = React.forwardRef(({ className, ...props }, ref) => (

    <th
      data-slot="table-head"
      className={cn(
        "h-12 px-4 text-left align-middle font-heading text-main-foreground [&:has([role=checkbox])]:pr-0",
        className
      )}
      {...props} />
  ))

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td
    data-slot="table-cell"
    className={cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", className)}
    {...props} />
))

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
  <caption
    data-slot="table-caption"
    className={cn("mt-4 text-sm text-foreground font-base", className)}
    {...props} />
))

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
}
